var SEARCHSPRING_KEY = '_isuid'

var generateUUID = function () {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ ((Math.random() * 16) >> (c / 4))).toString(16)
  })
}

var setCookie = function (params) {
  var name = params.name
  var value = params.value
  var days = params.days
  var unixTimestamp = params.unixTimestamp

  if (!navigator.cookieEnabled) {
    console.warn('Cookies are disabled on this browser')
    return
  }

  var expires = ''
  if (days) {
    var date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }

  if (unixTimestamp) {
    var expiryDate = new Date(parseInt(unixTimestamp.toString()))
    expires = '; expires=' + expiryDate.toUTCString()
  }

  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

var getCookie = function (name) {
  if (!navigator.cookieEnabled) {
    console.warn('Cookies are disabled on this browser')
    return null
  }

  var pair = document.cookie.match(new RegExp(name + '=([^;]+)'))
  return pair ? pair[1] : null
}

function deleteCookie(name) {
  if (!navigator.cookieEnabled) {
    console.warn('Cookies are disabled on this browser')
    return
  }

  document.cookie = name + '=' + ';expires=Thu, 01 Jan 1970 00:00:01 GMT'
}

var currentUid = getCookie(SEARCHSPRING_KEY)

if (!currentUid) {
  var createUuid = function () {
    currentUid = generateUUID() // Use the ES5 version of generateUUID
    return currentUid
  }

  setCookie({
    name: SEARCHSPRING_KEY,
    value: createUuid(),
    days: 365
  })

}

var setSSUserId = function () {
  var existingUserId = getCookie('ssUserId')

  if (!existingUserId) {
    setCookie({
      name: 'ssUserId',
      value: currentUid,
      days: 365
    })
  }
}

var setSsSessionIdNamespace = function () {
  var existingSessionId = getCookie('ssSessionIdNamespace')

  if (!existingSessionId) {
    setCookie({
      name: 'ssSessionIdNamespace',
      value: generateUUID()
    })
  }
}

var setSsPageLoadId = function () {
  sessionStorage.setItem('ss-page-load-id', generateUUID())
}

var setSsShopperId = function () {
  var existingShopperId = getCookie('ssShopperId')

  if (!existingShopperId) {
    setCookie({
      name: 'ssShopperId',
      value: GM_STATE.customer.id
    })
  }
}

setSsSessionIdNamespace()
setSSUserId()
setSsPageLoadId()

if (GM_STATE.customer.id) {
  setSsShopperId()
} else {
  deleteCookie('ssShopperId')
}